import { LEAD_STATUS_LABELS, leadStatusTone } from '../lib/marketplace';
import { ui } from '../lib/ui';

/** A marketplace lead's status as a pill (docs/Decisions.md D68, M2). */
const TONE = {
  success: ui.pillSuccess,
  warning: ui.pillWarning,
  danger: ui.pillDanger,
  neutral: ui.pillNeutral,
};

export default function LeadPill({ status }) {
  return (
    <span className={TONE[leadStatusTone(status)]}>{LEAD_STATUS_LABELS[status] || status}</span>
  );
}
